<template>
  <div class="list">
    <van-nav-bar title="我的收藏" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>

    <div class="item" v-for="item in list" :key="item.id" v-on:click="$router.push('/'+ module[item.module] +'/detail/'+item.goods_id)">
      <div class="l">
        <van-image fit="contain" :src="GLOBAL.IMG + item.goods_thumb" width="100" height="100" />
      </div>
      <div class="r">
        <div class="title">{{item.goods_title}}</div>
        <div class="price">¥{{item.goods_price}}</div>
        
      </div>
    </div>
    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
export default {
  name: "money",
  components: {
    TabBar
  },
  data() {
    return {
      list: [],
      user: { token: "", user: {} },
      module:['','shop','qiang','hui'],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_user/collection/select?module=&id=", {
          params: {},
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.list = data.data; //= data.data.data;
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.onLoad();
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: left;
  background-color: #f6f6f6;
  .item {
    background-color: #fff;
    display: flex;
    padding: 10px 10px 0 10px;
    margin-top: 10px;
    justify-content: space-between;
    .l {
        padding-right:10px;
    }
    .r {
      .title {
        line-height: 25px;
        height: 50px;
        overflow: hidden;
        padding: 0 5px 0 5px;
      }
      .price {
        color: red;
        text-align: left;
        padding: 0 5px 0 5px;
      }
    }
  }
}
</style>